/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

import listenForClick from "./clickHandler";
// console.log('hi');
jQuery(function(){
  handlePrintOutButtonClick();
  // handleBackButtonClick();
  handleDisableUsefulLinkTagClick();
  handleLatestPromotionMouseover();
  handlePDFButtonOnLatestPromotionPages();
  handleLatestPromotionClick();
  handleShowLightboxClick();
  handleHideLightboxClick();
  handleHideChangePassPopupClick();
  handleDownloadReportPhotoClick();
  //handleMobileHeaderPhoneIconClick();
  handleMobileHeaderSubMenuClick();
  handleContReadingClick();
  handleShareToFacebookClick();
  handleShareToSinaCNClick();
  /* handlePromoButtonClick(); */
  // handleContactFormSubmitClick();
  // handleUsefulLinksDropdownMenuClick();
});



jQuery(".search-form input[type=submit]").attr("value","搜索");

//列印Button on New Promotion pages
function handlePrintOutButtonClick() {
  jQuery('.fa-print, #print_and_PDF .elementor-icon-list-items li:first-child').on('click', function(event){
    event.preventDefault();
    window.print();
    return false;
  });
}


//下載PDF Button on New Promotion pages
function handlePDFButtonOnLatestPromotionPages() {

  jQuery('#print_and_PDF ul li:nth-child(2)').on('mouseover', function(event){
    jQuery(this).find('a').attr('download', '');

  });
  jQuery('#print_and_PDF ul li:nth-child(2)').on('click', function(event){
    event.preventDefault();
    //window.location.href = jQuery(this).attr('href');
    window.open(jQuery('#print_and_PDF ul li:nth-child(2) a').attr('href'), '_blank');
    //window.open(this).attr(href);
    //return false;
  });
}



//返回Button
// function handleBackButtonClick() {
//   jQuery('.back_to_events').on('click', function(event){
//     event.preventDefault();
//     //window.history.back();
//       window.open(window.location.origin+'/news/', '_self');
//   });
//   jQuery('.back_to_promo').on('click', function(event){
//     event.preventDefault();
//     //window.history.back();
//       window.open(window.location.origin+'/promotions/', '_self');
//   });
// }

//其他機構page
function handleDisableUsefulLinkTagClick() {
  jQuery('.page-useful-link  #useful-links nav').find('ul > li > a').on('click', function(event){
    if (!jQuery(this).parent().find('a.active').length) {
      jQuery('.page-useful-link  #useful-links nav').find('ul > li > a').removeClass("active");
      jQuery('.page-useful-link  #useful-links nav > ul > li').removeClass("active");
      jQuery(this).parent().addClass("active");
      jQuery(this).addClass("active");
    } else {
      jQuery('.page-useful-link  #useful-links nav').find('ul > li > a').removeClass("active");
      jQuery('.page-useful-link  #useful-links nav > ul > li').removeClass("active");
    }


  });
}

//Latest Promotion Pages
function handleLatestPromotionMouseover() {
  //jQuery('#new_promo .elementor-element').on('mouseover', function(event){
    jQuery('#promo-list article').on('mouseover', function(event){
      //event.preventDefault();
      jQuery(this).css("background-color", "#004071");
      jQuery(this).find('h2, .elementor-widget-container').css('color', '#FFFFFF');
    /* jQuery(this).find('.elementor-image-box-content').css("background-color", "#004071");
    jQuery(this).find('h3, p').css('color', '#FFFFFF'); */

    handleLatestPromotionMouseleave();
  });
}

function handleLatestPromotionMouseleave() {
  jQuery('#promo-list article').on('mouseleave', function(event){
    //event.preventDefault();
    jQuery(this).css("background-color", "#F1F2F2");
    jQuery(this).find('h2').css('color', '#004071');
    jQuery(this).find('.elementor-widget-container').css('color', '#000000');
  });
}

function handleLatestPromotionClick() {
  jQuery('#new_promo .elementor-image-box-content').on('click', function(event){
    // event.preventDefault();
    window.open(jQuery(this).find('a').attr('href'), '_self');
    //jQuery(this).parent().find('a').trigger('click');
  });
}

//console.log
function handleContReadingClick() {
  jQuery('#continue a').on('click', function(event){
    event.preventDefault();
    window.open(jQuery(this).parent().parent().parent().parent().find('.elementor-element:first-child h2 a').attr('href'), '_self');
    //jQuery(this).parent().find('a').trigger('click');
  });
  jQuery('#events_img div').on('click', function(event){
    event.preventDefault();
    window.open(jQuery(this).parent().parent().find('.elementor-element:first-child h2 a').attr('href'), '_self');
  });
}

function handleShowLightboxClick() {
  jQuery('#img-col img').on('click', function(event){
    jQuery('#promo-lightbox img').attr('src', jQuery('#img-col div.swiper-slide-active img').attr('src'));
    jQuery('#promo-lightbox img').attr('srcset', jQuery('#img-col div.swiper-slide-active img').attr('src'));

    window.scrollTo(0, 0);
    jQuery('#promo-lightbox').show();
  });
}
function handleHideLightboxClick() {
  jQuery('#promo-lightbox').on('click', function(event){
    jQuery(this).hide();
  });
}

function handleHideChangePassPopupClick() {
  jQuery('#change-pass-popup-backgound').on('click', function(event){
    jQuery(this).hide();
  });
}

function handleDownloadReportPhotoClick() {
  jQuery('#download_photo').on('click', function(event){
    event.preventDefault();
    window.open(jQuery(this).attr('href'), "_blank");
  });
}

/* function handleMobileHeaderPhoneIconClick() {
  jQuery('#contact .elementor-element:nth-child(2) a').on('click', function(event){
    event.preventDefault();
    //window.location.href = 'http://localhost/HKIC/contact/';
    window.open('tel:+852 26661821', '_self');
  });
} */

//header nav-menu - for mobile version
function handleMobileHeaderSubMenuClick() {
  jQuery('#menu-2-9180853 > li.menu-item-has-children').after().on('click', function(event){
    event.preventDefault();
    if(jQuery(this).children('ul').css('display') == "none") {
      jQuery(this).children('ul').css('display', 'block');
      jQuery(this).children('ul').addClass('active');
      jQuery(this).addClass('active');
    } else if (jQuery(this).children('ul').css('display') == "block") {
      jQuery(this).children('ul').css('display', 'none');
      jQuery(this).children('ul').removeClass('active');
      jQuery(this).removeClass('active');
    }

    //jQuery(this).addClass('active');
    //window.open('http://localhost/HKIC/service-listing/', '_self');
  });

  jQuery('#menu-2-9180853 > li:has(span.dropdown-menu-toggle) a').on('click', function(event){
    event.preventDefault();
    if(jQuery(this).parent().children('ul').css('display') == "none") {
      jQuery(this).parent().addClass('active');
      jQuery(this).children('span.dropdown-menu-toggle').addClass('active');
    } else if (jQuery(this).parent().children('ul').css('display') == "block") {
      jQuery(this).parent().removeClass('active');
      jQuery(this).children('span').removeClass('active');
    }
    //window.open('http://localhost/HKIC/service-listing/', '_self');
  });
  jQuery('#menu-2-9180853 > li:has(span.dropdown-menu-toggle)', '#menu-2-9180853 > li:has(span.dropdown-menu-toggle) a').on('mouseover', function(event){
    jQuery('#menu-2-9180853 ul').css('display', 'none');
  });
  jQuery('#menu-2-9180853 > li:has(span.dropdown-menu-toggle) a').on('click', function(event){
    event.preventDefault();
    window.open(jQuery(this).attr('href'), "_self");
  });
  jQuery('#menu-2-9180853 li > ul > li').on('click', function(event){
    event.preventDefault();
    window.open(jQuery(this).children('a').attr('href'), "_self");
  });

}

//企業消息及活動 Share Buttons
function handleShareToSinaCNClick() {
  jQuery('#social-sharing .elementor-social-icons-wrapper .elementor-grid-item:nth-child(2) path').on('click', function(event){
    event.preventDefault();
    let pageUrl = encodeURIComponent(document.URL);
    window.open("http://v.t.sina.com.cn/share/share.php?url=" + pageUrl, "_blank"); 
    //jQuery('#social-sharing .elementor-social-icons-wrapper .elementor-grid-item:nth-child(2)').css('background', "red");
  });
}
function handleShareToFacebookClick() {
  jQuery('#social-sharing .elementor-social-icons-wrapper .elementor-grid-item:first-child path').on('click', function(event){
    event.preventDefault();
    let pageUrl = encodeURIComponent(document.URL);
    window.open("https://www.facebook.com/sharer.php?u=" + pageUrl, "_blank"); 
    //jQuery('#social-sharing .elementor-social-icons-wrapper .elementor-grid-item:first-child').css('background', "red");
  });
}



/* function handlePromoButtonClick() {
  jQuery('#promo_button a').on('click', function(event){
    event.preventDefault();
    
    jQuery('#promo-list').css('display', 'block');
    jQuery('#promo-events').css('display', 'none');
    jQuery('#event_button a').removeClass("active");
    jQuery(this).addClass("active");
    jQuery(this).removeClass("inactive");
  });

  jQuery('#event_button a').on('click', function(event){
    event.preventDefault();
    
    jQuery('#promo-events').css('display', 'block');
    jQuery('#promo-list').css('display', 'none');
    jQuery('#promo_button a').removeClass("active");
    jQuery('#promo_button a').addClass("inactive");
    jQuery(this).addClass("active");
  });

} */

/* function handleContactFormSubmitClick() {
  jQuery('#gform_submit_button_1').on('click', function(event){
    window.location.href = "http://localhost/HKIC/contact-2/";
  });
} */





